import { Component } from '@angular/core';
import { faCalendarWeek, faCalendarCheck, faBuilding, faUsers, faAddressCard, faHotel, faHandHoldingHeart, faChartBar, faTable, faRoad, faCog, faPhone } from '@fortawesome/free-solid-svg-icons';
import { UserService } from 'src/app/_service/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  faCalendarWeek = faCalendarWeek
  faCalendarCheck = faCalendarCheck
  faBuilding = faBuilding
  faUsers = faUsers
  faAddressCard = faAddressCard
  faHotel = faHotel
  faHandHoldingHeart = faHandHoldingHeart
  faChartBar = faChartBar
  faTable = faTable;
  faRoad = faRoad;
  faCog = faCog;
  faPhone = faPhone;

  environment = environment;

  permissions: Array<string> = this.userService.permissions

  constructor(
    public userService: UserService,
  ) {
    setInterval(()=>{
      // console.log('this.userService.permissions', this.userService.permissions)
      this.permissions = this.userService.permissions
    }, 5000)
  }

}
